export default {
'_.lang.pl.text': 'polski',
'_.lang.en.text': 'english',
'_.lang.de.text': 'deutsch',
'_.lang.es.text': 'español',
'_.lang.it.text': 'italiano',
'_.lang.nl.text': 'nederlands',
'_.lang.ru.text': 'русский',
'_.lang.sk.text': 'slovenský',
'_.lang.cs.text': 'čeština',
'_.lang.uk.text': 'український',
'_.lang.ro.text': 'română',
'_.lang.fr.text': 'français',
'_.lang.hu.text': 'magyar',
'_.socialPoints': 'SocialPoints',
'_.cashPoints': 'CashPoints',
'_.pln': 'PLN',
'_.and': 'en',
'_.loadingSpinnerText': 'Wacht even...',
'pageTimerMax.text': 'Er zal automatisch overgaan na de volgende pagina na verloop van tijd.',
'pageTimerMax.timeLeft': 'Resterende tijd',
'pageTimerMin.text': 'Er is geen mogelijkheid om verder te gaan voordat de tijd is verstreken.',
'pageTimerMin.timeLeft': 'Resterende tijd',
'pageTimerMin.allowNext': 'U kunt verder gaan',
'survey.registerForm.label.email': 'E-mail',
'survey.registerForm.label.newsletter': 'Ik wil de nieuwsbrief ontvangen',
'survey.registerForm.label.regulations': 'Ik accepteer het Privacybeleid en de Algemene Voorwaarden',
'survey.registerForm.button.register': 'Registreer',
'survey.registerForm.registered': 'Bedankt voor je registratie. Er is een activatiemail verzonden naar uw inbox.',
'survey.registerForm.cardHeader': 'Registreer en ontvang punten!',
'survey.registerForm.cardBody': 'U hebt punten ontvangen voor het invullen van de enquête',
'survey.registerForm.cardBody2': 'De punten zullen worden toegevoegd na registratie van uw account op swpanel.pl. Voer uw e-mailadres in en registreer uw account op swpanel.pl',
'survey.notProperDevice': 'Helaas kunt u deze enquête niet op dit apparaat invullen.',
'survey.properDevices': 'De enquête is beschikbaar op de volgende apparaten:',
'survey.device-phone': 'smartphone',
'survey.device-tablet': 'tablet',
'survey.device-desktop': 'computer / laptop',
'nextSurveys.header.seeAlso': 'Bekijk ook andere enquêtes',
'nextSurveys.button.fill': 'Vul in',
'question.noContent': 'Geen inhoud van de vraag',
'question.input.placeholder.typeYourAnswer': 'Voer antwoord in',

'question.conjoint.go': 'Klik op "Volgende"',
'question.matrix.carousel.go': 'Klik op "Volgende"',
'question.carousel.prevBtn': 'Vorige verklaring',
'question.carousel.nextBtn': 'Volgende verklaring',

'question.open.email.inputPlaceholder': 'Voer e-mailadres in',
'question.open.email.emailVerify.sendCode': 'Verstuur verificatiecode',
'question.open.email.emailVerify.enderCode': 'Voer de ontvangen code in',
'question.open.email.emailVerify.enderCode.inputPlaceholder': 'Voer code in',
'question.open.email.emailVerify.confirm': 'Bevestigen',
'question.open.email.emailVerify.codeIncorrect': 'De ingevoerde code is onjuist',
'question.open.email.emailVerify.codeCorrect': 'E-mailadres correct geverifieerd',
'question.open.email.rodoText': 'The administrator of your personal data is SW Research Sp. z o.o. located at ul. J. Dąbrowskiego 64a, 02-561 Warszawa, Warsaw. For matters related to protecting your personal data and exercising your rights, you can contact the Data Protection Inspector at iod@swresearch.pl. Your personal data will be processed during the survey and accounting documentation for 5 years after the year the survey was completed. Your personal data will be processed for the purpose of participating in opinion surveys, analytical purposes to match our services to the needs of our clients, and for keeping accounting documentation (Article 6 (1) (b) of the GDPR(RODO), Article 6 (1) (f) of the GDPR(RODO), Article 6 (1) (c) of the GDPR(RODO) in connection with Article 86 § 1 of the Tax Ordinance).',

'footer.pauseButton.text': 'Stop invullen',
'footer.buttonPrev.text': 'Terug',
'footer.buttonClear.text': 'Wissen',
'footer.buttonNext.text': 'Volgende',
'footer.buttonEnd.text': 'Eindig',
'footer.buttonStart.text': 'Start enquête',
'question.matrix.nextStatement': 'Volgende verklaring',
'question.matrix.previousStatement': 'Vorige verklaring',
};
